import styled from 'styled-components';
// import color from '../../configs/color';
// import breakpoints from '../../configs/breakpoints'

const Wrapper = styled.div`
  .component_contact_details_top {
    margin-top: 34px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 24px;
  }

  .component_contact_details_two_columns {
    margin-top: 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;

    .ant-row.ant-form-item:nth-child(2) {
      margin-top: 2px;
    }
  }

  .ant-divider-horizontal {
    margin-top: 10px;
  }

  .component_contact_details_streets {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;

    textarea {
      height: 140px;
    }
  }

  .component_contact_details_location_row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;
  }
`;

export default Wrapper;
